export const generateTestId = ({ testId, suffix }) => {
    if (!testId)
        return;
    return suffix ? `${testId}-${suffix}` : testId;
};
